import React from 'react';
import { Box, Grid, Typography, Card, CardContent, Avatar, Stack, Chip, Button, Divider } from '@mui/material';
import usePortfolioStore from '../store/portfolioStore.js';

export default function About() {
  const { contacts, about, skillsCatalog } = usePortfolioStore();

  const experiences = [
    {
      title: 'Lead Software Engineer',
      company: 'Hikmah Tech',
      type: 'Full-Time',
      period: 'Feb 2026 – Present',
      location: 'Karachi, Sindh, Pakistan · Onsite',
      highlights: ['Next.js', 'ASP .Net Web API', 'SQL', 'Azure', 'Project Management', 'Team Leadership', 'Product Development', 'and +5 more']
    },
    {
      title: 'Founder & Senior Software Engineer',
      company: 'WORLD OF TECH PVT LTD',
      type: 'Full-time',
      period: 'Mar 2023 – Present',
      location: 'Karachi, Sindh, Pakistan · Remote',
      highlights: ['MERN Stack', 'Project Management', 'Client Acquisition', 'Production Deployment', 'Google Adsense Integration', 'Google Analytics Setup', 'and +19 skills']
    },
    {
      title: 'MERN & Laravel - Full-Stack Developer',
      company: 'Envision Xperts',
      type: 'Full-time',
      period: 'Nov 2024 – Feb 2026',
      location: 'Karachi, Sindh, Pakistan · On-site',
      highlights: ['Magento', 'MERN Stack', 'Laravel', 'Custom Wordpress Theme & Plugin Development', 'UI/UX Design', 'Product Development', 'and +3 more']
    },
    
    {
      title: 'Business Development Specialist',
      company: 'Prime Vertex Softwares',
      type: 'Contract',
      period: 'Nov 2024 – Aug 2025',
      location: 'United States · Remote',
      highlights: ['WordPress', 'SEO', 'Digital Marketing', 'Client Acquisition', 'Sales Strategy', 'Business Development', 'and +5 more']
    }
  ];

  const profileSrc = '/Mesum.jpg';
  const aboutText = `I specialize in developing and designing modern, responsive websites tailored to meet your business needs. From sleek portfolios to fully functional e-commerce platforms, I create websites that not only look great but also deliver seamless user experiences.

In addition to web design, I offer Search Engine Optimization (SEO) services to help your site rank higher, attract more visitors, and drive meaningful engagement. Whether you need a brand-new website or want to optimize your existing one, I can handle it all with dedication and precision.

I am passionate about every project I take on, striving to exceed expectations with top-notch results. If you entrust me with your website, I guarantee professional service, timely delivery, and outcomes that will inspire and impress you.

Let’s work together to bring your vision to life. I’m confident that my expertise and commitment will not just meet but surpass your expectations.`;

  return (
    <Box>
      <Grid container spacing={3} alignItems="center">
        <Grid item xs={12} md={4}>
          <Card className="glass" sx={{ overflow: 'hidden' }}>
            <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <Avatar src={profileSrc} alt="Mesum Bin Shaukat" sx={{ width: 160, height: 160, mb: 2 }} />
              <Typography variant="h6" gutterBottom>Mesum Bin Shaukat</Typography>
              <Typography variant="body2" sx={{ opacity: .85, textAlign: 'center' }}>{about.headline}</Typography>
              <Divider sx={{ my: 2, width: '100%', opacity: .2 }} />
              <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap" justifyContent="center">
                <Chip label={`WhatsApp: ${contacts.whatsapp}`} component="a" href={`https://wa.me/${contacts.whatsapp.replace(/[^\d]/g,'')}`} clickable />
                <Chip label={`Email: ${contacts.email}`} component="a" href={`mailto:${contacts.email}`} clickable />
                <Chip label="LinkedIn" component="a" href={contacts.socials.linkedin} clickable />
                <Chip label="GitHub" component="a" href={contacts.socials.github} clickable />
                <Chip label="Instagram" component="a" href={contacts.socials.instagram} clickable />
              </Stack>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={8}>
          <Card className="glass">
            <CardContent>
              <Typography variant="h5" gutterBottom>About</Typography>
              <Typography variant="body1" sx={{ opacity: .9, whiteSpace: 'pre-line' }}>{aboutText}</Typography>
              <Box sx={{ mt: 2 }}>
                <Button variant="contained" href={contacts.socials.linkedin} target="_blank" rel="noreferrer" sx={{ mr: 1 }}>Connect on LinkedIn</Button>
                <Button variant="outlined" component="a" href={`mailto:${contacts.email}`}>Email Me</Button>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Box className="section">
        <Typography variant="h5" gutterBottom>Experience</Typography>
        <Grid container spacing={2}>
          {experiences.map((exp, idx) => (
            <Grid item xs={12} md={4} key={idx}>
              <Card className="glass">
                <CardContent>
                  <Typography variant="subtitle1" fontWeight={600}>{exp.title}</Typography>
                  <Typography variant="body2" sx={{ opacity: .9 }}>{exp.company} · {exp.type}</Typography>
                  <Typography variant="caption" sx={{ opacity: .7, display: 'block', marginTop: '.5rem' }}>{exp.period}</Typography>
                  <Typography variant="caption" sx={{ opacity: .7, display: 'block' }}>{exp.location}</Typography>
                  <Stack direction="row" spacing={1} sx={{ mt: 1 }} useFlexGap flexWrap="wrap">
                    {exp.highlights.map(h => <Chip key={h} size="small" label={h} />)}
                  </Stack>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>

      <Box className="section">
        <Typography variant="h5" gutterBottom>Capabilities Snapshot</Typography>
        <Grid container spacing={2}>
          {skillsCatalog.slice(0, 4).map(cat => (
            <Grid item xs={12} md={6} key={cat.category}>
              <Card className="glass">
                <CardContent>
                  <Typography variant="h6" gutterBottom>{cat.category}</Typography>
                  <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
                    {cat.items.map(s => <Chip key={s} label={s} />)}
                  </Stack>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
}
